// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"8df46397","310":"ee683015","336":"855096b0","522":"30c2b405","578":"9d7cd1eb"}[chunkId] + ".chunk.js";
};